import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import LogoNav from '../../../components/logoNav';
import Search from '@ifeng/ui_pc_search/';
import UserInfo from '@ifeng/ui_pc_userInfo/';

class Header extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    render() {
        const { content } = this.props;
        const { search, columnData, nav } = content;
        const logoData = { logoData: columnData ? columnData.logo : {}, navData: nav };
        /**
         * 组件分发数据
         */

        return (
            <div>
                <div className={style.header}>
                    <div className={style.header_bar}>
                        <LogoNav content={logoData} />
                        <div className={style.box}>
                            <div className={style.search}>
                                <Search expand content={search} />
                            </div>
                            <div className={style.user}>
                                <UserInfo iconShow option={['login']} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default errorBoundary(Header);
